import { createColumn, createDropdownColumn } from "../components/Table/Table";

export const escalatorVersionColumns: State.Column[] = [
  createColumn(
    "Number",
    (escalatorVersion: Api.EscalatorVersion) => escalatorVersion.number,
    "escalatorVersion.number",
    true
  ),
  createColumn(
    "Name",
    (escalatorVersion: Api.EscalatorVersion) => escalatorVersion.versionName,
    "escalatorVersion.versionName",
    true
  ),
  createColumn(
    "Comment",
    (escalatorVersion: Api.EscalatorVersion) => escalatorVersion.description,
    "escalatorVersion.description",
    true
  ),
  createDropdownColumn(
    "Domain",
    (escalatorVersion: Api.EscalatorVersion) => escalatorVersion.domainName,
    "escalatorVersion.domainName",
    true
  )
];
